export default __webpack_public_path__ + "static/media/calendarCompleted.32f9b258.svg";